import { ROLE_LABEL, type UserSummary } from '@qlk/shared';
import { LogOut } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { Avatar } from '../ui/Avatar.js';

export function nhanVaiTro(user: UserSummary): string {
  if (user.roles.includes('admin')) return 'Toàn quyền';
  if (user.roles.length === 0) return 'Chưa gán vai trò';
  return user.roles.map((r) => ROLE_LABEL[r]).join(', ');
}

export interface UserCardProps {
  user: UserSummary;
  onDangXuat: () => void;
  dangDangXuat?: boolean;
  /** Đóng thanh bên trên điện thoại sau khi bấm vào thẻ. */
  onChon?: () => void;
  /** Thanh bên đang thu gọn còn icon: chỉ còn avatar và nút đăng xuất. */
  gon?: boolean;
}

/**
 * Thẻ người dùng ở góc dưới thanh bên **tối**.
 *
 * Phần thông tin là liên kết sang `/tai-khoan` (đổi email và mật khẩu); nút đăng
 * xuất tách riêng bên phải để không bấm nhầm. Hiện email thay cho nhãn vai trò:
 * đây là tên đăng nhập, và là thứ người dùng cần đối chiếu sau khi đổi.
 */
export function UserCard({
  user,
  onDangXuat,
  dangDangXuat = false,
  onChon,
  gon = false,
}: UserCardProps) {
  return (
    <div
      className={`m-2 flex items-center gap-1 rounded-o bg-menu-muc p-1.5 ${
        /* Thu gọn: xếp dọc, avatar trên nút đăng xuất — hai thứ cạnh nhau
           trong 64px thì mỗi thứ còn chưa tới 28px. */
        gon ? 'flex-col' : ''
      }`}
    >
      <NavLink
        to="/tai-khoan"
        onClick={onChon}
        title="Tài khoản của tôi"
        // Tên hiển thị là tên + email, nên đặt nhãn riêng cho trình đọc màn
        // hình (và cho test) biết liên kết này đi đâu.
        aria-label="Tài khoản của tôi"
        className={({ isActive }) =>
          `flex min-h-10 min-w-0 items-center gap-2.5 rounded-o transition-colors ${
            gon ? 'justify-center px-1.5 py-1' : 'flex-1 px-1.5 py-1'
          } ${isActive ? 'bg-white/10' : 'hover:bg-white/10'}`
        }
      >
        <Avatar name={user.name} color={user.avatarColor} size={30} />
        {!gon && (
          <span className="min-w-0 flex-1">
            <span className="block truncate text-co-ban font-semibold text-white">{user.name}</span>
            <span className="block truncate text-phu text-menu-nhom">{user.email}</span>
          </span>
        )}
      </NavLink>

      <button
        type="button"
        onClick={onDangXuat}
        disabled={dangDangXuat}
        aria-label="Đăng xuất"
        title="Đăng xuất"
        className="inline-flex size-9 shrink-0 items-center justify-center rounded-o text-menu-chu hover:bg-white/10 hover:text-white disabled:opacity-50"
      >
        <LogOut size={18} aria-hidden="true" />
      </button>
    </div>
  );
}
